import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ServiceLocator } from './service-locator';
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function highchartsFactory() {
    var hc = require('highcharts');
    var hcm = require('highcharts/highcharts-more');
    var solidGauge = require('highcharts/modules/solid-gauge');
    var hcBorder = require('highcharts-border-radius/index');
    hcm(hc);
    solidGauge(hc);
    hcBorder(hc);
    return hc;
}
var DEFAULT_DROPZONE_CONFIG = {
    url: 'http://ws.getachoo.com/campaign/uploadFile',
    maxFilesize: 50,
    acceptedFiles: 'image/*'
};
var ɵ0 = DEFAULT_DROPZONE_CONFIG;
var SharedModule = /** @class */ (function () {
    function SharedModule(injector) {
        this.injector = injector;
        ServiceLocator.injector = injector;
    }
    return SharedModule;
}());
export { SharedModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/shared.module.ts.pre-build-optimizer.js